<template>
  <div class="sidebar-inner">
    <!-- Top Section -->
    <div class="top-section">
      <h4 class="mb-1">Related Tickets</h4>
      <hr>
      <!-- Is Loading -->
      <div class="text-center mt-4" v-if="isLoadingRelatedTickets">
        <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
      </div>
      <!-- / Is Loading -->

      <!-- Loaded -->
      <div v-if="!isLoadingRelatedTickets && relatedTickets !== null">
        <div class="audit-data mt-3" v-if="relatedTickets.length === 0">
          <div class="property-card">
            <b class="property-name text-danger">
              No related tickets to show
            </b>
          </div>
        </div>
      </div>
      <!-- / Loaded -->

      <!-- Has Related Tickets -->
      <div v-if="!isLoadingRelatedTickets && relatedTickets.length">
        <related-ticket v-for="ticket in relatedTickets" :key="ticket.id"
                        :ticket="ticket"
        ></related-ticket>
      </div>
      <!-- / Has Related Tickets -->
    </div>
    <!-- / Top Section -->
    <!-- Bottom Section -->
    <div class="bottom-section pt-3 pb-3">
      <a href="#" @click.prevent="loadRelatedTickets" class="btn btn-itg-dark btn-block">
        <i class="fa fa-sync mr-1"></i>
        Refresh
      </a>
    </div>
    <!-- / Bottom Section -->
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import RelatedTicket from "../../../../../components/RelatedTicket";
const _ = require('lodash');

export default {
  name: "RelatedTicketsSidebar",
  computed: {
    ...mapGetters('ticketViewer', {
      isLoadingRelatedTickets: 'isLoadingRelatedTickets',
      relatedTickets: 'relatedTickets'
    })
  },
  created() {
    this.loadRelatedTickets();
  },
  methods: {
    ...mapActions('ticketViewer', {
      loadRelatedTickets: 'loadRelatedTickets'
    })
  },
  components: {RelatedTicket}
}
</script>

<style lang="scss" scoped>
.property-card {
    background: #fff;
    border-radius: 5px;
    padding: 15px;

    .property-name {
        font-weight: 600;
        color: #2c5cc5;
    }
}
</style>